const state = {
    provinciasEspana: [
        'Álava',
        'Albacete',
        'Alicante',
        'Almería',
        'Asturias',
        'Ávila',
        'Badajoz',
        'Barcelona',
        'Burgos',
        'Cáceres',
        'Cádiz',
        'Cantabria',
        'Castellón',
        'Ciudad Real',
        'Córdoba',
        'A Coruña',
        'Cuenca',
        'Girona',
        'Granada',
        'Guadalajara',
        'Gipuzkoa',
        'Huelva',
        'Huesca',
        'Islas Baleares',
        'Jaén',
        'León',
        'Lleida',
        'Lugo',
        'Madrid',
        'Málaga',
        'Murcia',
        'Navarra',
        'Ourense',
        'Palencia',
        'Las Palmas',
        'Pontevedra',
        'La Rioja',
        'Salamanca',
        'Santa Cruz de Tenerife',
        'Segovia',
        'Sevilla',
        'Soria',
        'Tarragona',
        'Teruel',
        'Toledo',
        'Valencia',
        'Valladolid',
        'Bizkaia',
        'Zamora',
        'Zaragoza',
        'Ceuta',
        'Melilla'
    ],
    codigosPais: [
        {
            name: 'España',
            dial_code: '+34',
            code: 'ES'
        },
        {
            name: 'Afganistán',
            dial_code: '+93',
            code: 'AF'
        },
        {
            name: 'Albania',
            dial_code: '+355',
            code: 'AL'
        },
        {
            name: 'Alemania',
            dial_code: '+49',
            code: 'DE'
        },
        {
            name: 'Andorra',
            dial_code: '+376',
            code: 'AD'
        },
        {
            name: 'Angola',
            dial_code: '+244',
            code: 'AO'
        },
        {
            name: 'Anguila',
            dial_code: '+1 264',
            code: 'AI'
        },
        {
            name: 'Antigua y Barbuda',
            dial_code: '+1 268',
            code: 'AG'
        },
        {
            name: 'Antillas Neerlandesas',
            dial_code: '+599',
            code: 'AN'
        },
        {
            name: 'Arabia Saudita',
            dial_code: '+966',
            code: 'SA'
        },
        {
            name: 'Argelia',
            dial_code: '+213',
            code: 'DZ'
        },
        {
            name: 'Argentina',
            dial_code: '+54',
            code: 'AR'
        },
        {
            name: 'Armenia',
            dial_code: '+374',
            code: 'AM'
        },
        {
            name: 'Aruba',
            dial_code: '+297',
            code: 'AW'
        },
        {
            name: 'Australia',
            dial_code: '+61',
            code: 'AU'
        },
        {
            name: 'Austria',
            dial_code: '+43',
            code: 'AT'
        },
        {
            name: 'Azerbaiyán',
            dial_code: '+994',
            code: 'AZ'
        },
        {
            name: 'Bahamas',
            dial_code: '+1 242',
            code: 'BS'
        },
        {
            name: 'Bahrein',
            dial_code: '+973',
            code: 'BH'
        },
        {
            name: 'Bangladesh',
            dial_code: '+880',
            code: 'BD'
        },
        {
            name: 'Barbados',
            dial_code: '+1 246',
            code: 'BB'
        },
        {
            name: 'Bélgica',
            dial_code: '+32',
            code: 'BE'
        },
        {
            name: 'Belice',
            dial_code: '+501',
            code: 'BZ'
        },
        {
            name: 'Benín',
            dial_code: '+229',
            code: 'BJ'
        },
        {
            name: 'Bhután',
            dial_code: '+975',
            code: 'BT'
        },
        {
            name: 'Bielorrusia',
            dial_code: '+375',
            code: 'BY'
        },
        {
            name: 'Bolivia',
            dial_code: '+591',
            code: 'BO'
        },
        {
            name: 'Bosnia y Herzegovina',
            dial_code: '+387',
            code: 'BA'
        },
        {
            name: 'Botswana',
            dial_code: '+267',
            code: 'BW'
        },
        {
            name: 'Brasil',
            dial_code: '+55',
            code: 'BR'
        },
        {
            name: 'Brunéi',
            dial_code: '+673',
            code: 'BN'
        },
        {
            name: 'Bulgaria',
            dial_code: '+359',
            code: 'BG'
        },
        {
            name: 'Burkina Faso',
            dial_code: '+226',
            code: 'BF'
        },
        {
            name: 'Burundi',
            dial_code: '+257',
            code: 'BI'
        },
        {
            name: 'Cabo Verde',
            dial_code: '+238',
            code: 'CV'
        },
        {
            name: 'Camboya',
            dial_code: '+855',
            code: 'KH'
        },
        {
            name: 'Camerún',
            dial_code: '+237',
            code: 'CM'
        },
        {
            name: 'Canadá',
            dial_code: '+1',
            code: 'CA'
        },
        {
            name: 'Catar',
            dial_code: '+974',
            code: 'QA'
        },
        {
            name: 'Chad',
            dial_code: '+235',
            code: 'TD'
        },
        {
            name: 'Chile',
            dial_code: '+56',
            code: 'CL'
        },
        {
            name: 'China',
            dial_code: '+86',
            code: 'CN'
        },
        {
            name: 'Chipre',
            dial_code: '+357',
            code: 'CY'
        },
        {
            name: 'Ciudad del Vaticano',
            dial_code: '+379',
            code: 'VA'
        },
        {
            name: 'Colombia',
            dial_code: '+57',
            code: 'CO'
        },
        {
            name: 'Comoras',
            dial_code: '+269',
            code: 'KM'
        },
        {
            name: 'Congo',
            dial_code: '+242',
            code: 'CG'
        },
        {
            name: 'Corea del Norte',
            dial_code: '+850',
            code: 'KP'
        },
        {
            name: 'Corea del Sur',
            dial_code: '+82',
            code: 'KR'
        },
        {
            name: 'Costa de Marfil',
            dial_code: '+225',
            code: 'CI'
        },
        {
            name: 'Costa Rica',
            dial_code: '+506',
            code: 'CR'
        },
        {
            name: 'Croacia',
            dial_code: '+385',
            code: 'HR'
        },
        {
            name: 'Cuba',
            dial_code: '+53',
            code: 'CU'
        },
        {
            name: 'Dinamarca',
            dial_code: '+45',
            code: 'DK'
        },
        {
            name: 'Dominica',
            dial_code: '+1 767',
            code: 'DM'
        },
        {
            name: 'Ecuador',
            dial_code: '+593',
            code: 'EC'
        },
        {
            name: 'Egipto',
            dial_code: '+20',
            code: 'EG'
        },
        {
            name: 'El Salvador',
            dial_code: '+503',
            code: 'SV'
        },
        {
            name: 'Emiratos Árabes Unidos',
            dial_code: '+971',
            code: 'AE'
        },
        {
            name: 'Eritrea',
            dial_code: '+291',
            code: 'ER'
        },
        {
            name: 'Eslovaquia',
            dial_code: '+421',
            code: 'SK'
        },
        {
            name: 'Eslovenia',
            dial_code: '+386',
            code: 'SI'
        },
        {
            name: 'Estados Unidos',
            dial_code: '+1',
            code: 'US'
        },
        {
            name: 'Estonia',
            dial_code: '+372',
            code: 'EE'
        },
        {
            name: 'Etiopía',
            dial_code: '+251',
            code: 'ET'
        },
        {
            name: 'Filipinas',
            dial_code: '+63',
            code: 'PH'
        },
        {
            name: 'Finlandia',
            dial_code: '+358',
            code: 'FI'
        },
        {
            name: 'Fiyi',
            dial_code: '+679',
            code: 'FJ'
        },
        {
            name: 'Francia',
            dial_code: '+33',
            code: 'FR'
        },
        {
            name: 'Gabón',
            dial_code: '+241',
            code: 'GA'
        },
        {
            name: 'Gambia',
            dial_code: '+220',
            code: 'GM'
        },
        {
            name: 'Georgia',
            dial_code: '+995',
            code: 'GE'
        },
        {
            name: 'Ghana',
            dial_code: '+233',
            code: 'GH'
        },
        {
            name: 'Gibraltar',
            dial_code: '+350',
            code: 'GI'
        },
        {
            name: 'Granada',
            dial_code: '+1 473',
            code: 'GD'
        },
        {
            name: 'Grecia',
            dial_code: '+30',
            code: 'GR'
        },
        {
            name: 'Groenlandia',
            dial_code: '+299',
            code: 'GL'
        },
        {
            name: 'Guadalupe',
            dial_code: '+590',
            code: 'GP'
        },
        {
            name: 'Guam',
            dial_code: '+1 671',
            code: 'GU'
        },
        {
            name: 'Guatemala',
            dial_code: '+502',
            code: 'GT'
        },
        {
            name: 'Guayana Francesa',
            dial_code: '+594',
            code: 'GF'
        },
        {
            name: 'Guinea',
            dial_code: '+224',
            code: 'GN'
        },
        {
            name: 'Guinea Ecuatorial',
            dial_code: '+240',
            code: 'GQ'
        },
        {
            name: 'Guinea-Bisáu',
            dial_code: '+245',
            code: 'GW'
        },
        {
            name: 'Guyana',
            dial_code: '+592',
            code: 'GY'
        },
        {
            name: 'Haití',
            dial_code: '+509',
            code: 'HT'
        },
        {
            name: 'Honduras',
            dial_code: '+504',
            code: 'HN'
        },
        {
            name: 'Hong Kong',
            dial_code: '+852',
            code: 'HK'
        },
        {
            name: 'Hungría',
            dial_code: '+36',
            code: 'HU'
        },
        {
            name: 'India',
            dial_code: '+91',
            code: 'IN'
        },
        {
            name: 'Indonesia',
            dial_code: '+62',
            code: 'ID'
        },
        {
            name: 'Irán',
            dial_code: '+98',
            code: 'IR'
        },
        {
            name: 'Irak',
            dial_code: '+964',
            code: 'IQ'
        },
        {
            name: 'Irlanda',
            dial_code: '+353',
            code: 'IE'
        },
        {
            name: 'Islandia',
            dial_code: '+354',
            code: 'IS'
        },
        {
            name: 'Islas Caimán',
            dial_code: '+1 345',
            code: 'KY'
        },
        {
            name: 'Islas Cook',
            dial_code: '+682',
            code: 'CK'
        },
        {
            name: 'Islas Feroe',
            dial_code: '+298',
            code: 'FO'
        },
        {
            name: 'Islas Malvinas',
            dial_code: '+500',
            code: 'FK'
        },
        {
            name: 'Islas Marshall',
            dial_code: '+692',
            code: 'MH'
        },
        {
            name: 'Islas Salomón',
            dial_code: '+677',
            code: 'SB'
        },
        {
            name: 'Islas Turcas y Caicos',
            dial_code: '+1 649',
            code: 'TC'
        },
        {
            name: 'Islas Vírgenes Británicas',
            dial_code: '+1 284',
            code: 'VG'
        },
        {
            name: 'Islas Vírgenes de los Estados Unidos',
            dial_code: '+1 340',
            code: 'VI'
        },
        {
            name: 'Israel',
            dial_code: '+972',
            code: 'IL'
        },
        {
            name: 'Italia',
            dial_code: '+39',
            code: 'IT'
        },
        {
            name: 'Jamaica',
            dial_code: '+1 876',
            code: 'JM'
        },
        {
            name: 'Japón',
            dial_code: '+81',
            code: 'JP'
        },
        {
            name: 'Jordania',
            dial_code: '+962',
            code: 'JO'
        },
        {
            name: 'Kazajistán',
            dial_code: '+7',
            code: 'KZ'
        },
        {
            name: 'Kenia',
            dial_code: '+254',
            code: 'KE'
        },
        {
            name: 'Kirguistán',
            dial_code: '+996',
            code: 'KG'
        },
        {
            name: 'Kiribati',
            dial_code: '+686',
            code: 'KI'
        },
        {
            name: 'Kuwait',
            dial_code: '+965',
            code: 'KW'
        },
        {
            name: 'Laos',
            dial_code: '+856',
            code: 'LA'
        },
        {
            name: 'Lesoto',
            dial_code: '+266',
            code: 'LS'
        },
        {
            name: 'Letonia',
            dial_code: '+371',
            code: 'LV'
        },
        {
            name: 'Líbano',
            dial_code: '+961',
            code: 'LB'
        },
        {
            name: 'Liberia',
            dial_code: '+231',
            code: 'LR'
        },
        {
            name: 'Libia',
            dial_code: '+218',
            code: 'LY'
        },
        {
            name: 'Liechtenstein',
            dial_code: '+423',
            code: 'LI'
        },
        {
            name: 'Lituania',
            dial_code: '+370',
            code: 'LT'
        },
        {
            name: 'Luxemburgo',
            dial_code: '+352',
            code: 'LU'
        },
        {
            name: 'Macao',
            dial_code: '+853',
            code: 'MO'
        },
        {
            name: 'Macedonia',
            dial_code: '+389',
            code: 'MK'
        },
        {
            name: 'Madagascar',
            dial_code: '+261',
            code: 'MG'
        },
        {
            name: 'Malasia',
            dial_code: '+60',
            code: 'MY'
        },
        {
            name: 'Malaui',
            dial_code: '+265',
            code: 'MW'
        },
        {
            name: 'Maldivas',
            dial_code: '+960',
            code: 'MV'
        },
        {
            name: 'Malí',
            dial_code: '+223',
            code: 'ML'
        },
        {
            name: 'Malta',
            dial_code: '+356',
            code: 'MT'
        },
        {
            name: 'Marruecos',
            dial_code: '+212',
            code: 'MA'
        },
        {
            name: 'Martinica',
            dial_code: '+596',
            code: 'MQ'
        },
        {
            name: 'Mauricio',
            dial_code: '+230',
            code: 'MU'
        },
        {
            name: 'Mauritania',
            dial_code: '+222',
            code: 'MR'
        },
        {
            name: 'México',
            dial_code: '+52',
            code: 'MX'
        },
        {
            name: 'Micronesia',
            dial_code: '+691',
            code: 'FM'
        },
        {
            name: 'Moldavia',
            dial_code: '+373',
            code: 'MD'
        },
        {
            name: 'Mónaco',
            dial_code: '+377',
            code: 'MC'
        },
        {
            name: 'Mongolia',
            dial_code: '+976',
            code: 'MN'
        },
        {
            name: 'Montenegro',
            dial_code: '+382',
            code: 'ME'
        },
        {
            name: 'Montserrat',
            dial_code: '+1 664',
            code: 'MS'
        },
        {
            name: 'Mozambique',
            dial_code: '+258',
            code: 'MZ'
        },
        {
            name: 'Myanmar',
            dial_code: '+95',
            code: 'MM'
        },
        {
            name: 'Namibia',
            dial_code: '+264',
            code: 'NA'
        },
        {
            name: 'Nauru',
            dial_code: '+674',
            code: 'NR'
        },
        {
            name: 'Nepal',
            dial_code: '+977',
            code: 'NP'
        },
        {
            name: 'Nicaragua',
            dial_code: '+505',
            code: 'NI'
        },
        {
            name: 'Níger',
            dial_code: '+227',
            code: 'NE'
        },
        {
            name: 'Nigeria',
            dial_code: '+234',
            code: 'NG'
        },
        {
            name: 'Noruega',
            dial_code: '+47',
            code: 'NO'
        },
        {
            name: 'Nueva Caledonia',
            dial_code: '+687',
            code: 'NC'
        },
        {
            name: 'Nueva Zelanda',
            dial_code: '+64',
            code: 'NZ'
        },
        {
            name: 'Omán',
            dial_code: '+968',
            code: 'OM'
        },
        {
            name: 'Países Bajos',
            dial_code: '+31',
            code: 'NL'
        },
        {
            name: 'Pakistán',
            dial_code: '+92',
            code: 'PK'
        },
        {
            name: 'Palau',
            dial_code: '+680',
            code: 'PW'
        },
        {
            name: 'Palestina',
            dial_code: '+970',
            code: 'PS'
        },
        {
            name: 'Panamá',
            dial_code: '+507',
            code: 'PA'
        },
        {
            name: 'Papúa Nueva Guinea',
            dial_code: '+675',
            code: 'PG'
        },
        {
            name: 'Paraguay',
            dial_code: '+595',
            code: 'PY'
        },
        {
            name: 'Perú',
            dial_code: '+51',
            code: 'PE'
        },
        {
            name: 'Polonia',
            dial_code: '+48',
            code: 'PL'
        },
        {
            name: 'Portugal',
            dial_code: '+351',
            code: 'PT'
        },
        {
            name: 'Puerto Rico',
            dial_code: '+1 939',
            code: 'PR'
        },
        {
            name: 'Qatar',
            dial_code: '+974',
            code: 'QA'
        },
        {
            name: 'Reino Unido',
            dial_code: '+44',
            code: 'GB'
        },
        {
            name: 'República Centroafricana',
            dial_code: '+236',
            code: 'CF'
        },
        {
            name: 'República Checa',
            dial_code: '+420',
            code: 'CZ'
        },
        {
            name: 'República Dominicana',
            dial_code: '+1 809',
            code: 'DO'
        },
        {
            name: 'República Sudafricana',
            dial_code: '+27',
            code: 'ZA'
        },
        {
            name: 'Ruanda',
            dial_code: '+250',
            code: 'RW'
        },
        {
            name: 'Rumanía',
            dial_code: '+40',
            code: 'RO'
        },
        {
            name: 'Rusia',
            dial_code: '+7',
            code: 'RU'
        },
        {
            name: 'Samoa',
            dial_code: '+685',
            code: 'WS'
        },
        {
            name: 'Samoa Americana',
            dial_code: '+1 684',
            code: 'AS'
        },
        {
            name: 'San Cristóbal y Nieves',
            dial_code: '+1 869',
            code: 'KN'
        },
        {
            name: 'San Marino',
            dial_code: '+378',
            code: 'SM'
        },
        {
            name: 'San Pedro y Miquelón',
            dial_code: '+508',
            code: 'PM'
        },
        {
            name: 'San Vicente y las Granadinas',
            dial_code: '+1 784',
            code: 'VC'
        },
        {
            name: 'Santa Lucía',
            dial_code: '+1 758',
            code: 'LC'
        },
        {
            name: 'Santo Tomé y Príncipe',
            dial_code: '+239',
            code: 'ST'
        },
        {
            name: 'Senegal',
            dial_code: '+221',
            code: 'SN'
        },
        {
            name: 'Serbia',
            dial_code: '+381',
            code: 'RS'
        },
        {
            name: 'Seychelles',
            dial_code: '+248',
            code: 'SC'
        },
        {
            name: 'Sierra Leona',
            dial_code: '+232',
            code: 'SL'
        },
        {
            name: 'Singapur',
            dial_code: '+65',
            code: 'SG'
        },
        {
            name: 'Siria',
            dial_code: '+963',
            code: 'SY'
        },
        {
            name: 'Somalia',
            dial_code: '+252',
            code: 'SO'
        },
        {
            name: 'Sri Lanka',
            dial_code: '+94',
            code: 'LK'
        },
        {
            name: 'Suazilandia',
            dial_code: '+268',
            code: 'SZ'
        },
        {
            name: 'Sudán',
            dial_code: '+249',
            code: 'SD'
        },
        {
            name: 'Suecia',
            dial_code: '+46',
            code: 'SE'
        },
        {
            name: 'Suiza',
            dial_code: '+41',
            code: 'CH'
        },
        {
            name: 'Surinam',
            dial_code: '+597',
            code: 'SR'
        },
        {
            name: 'Tailandia',
            dial_code: '+66',
            code: 'TH'
        },
        {
            name: 'Tanzania',
            dial_code: '+255',
            code: 'TZ'
        },
        {
            name: 'Tayikistán',
            dial_code: '+992',
            code: 'TJ'
        },
        {
            name: 'Timor Oriental',
            dial_code: '+670',
            code: 'TL'
        },
        {
            name: 'Togo',
            dial_code: '+228',
            code: 'TG'
        },
        {
            name: 'Tokelau',
            dial_code: '+690',
            code: 'TK'
        },
        {
            name: 'Tonga',
            dial_code: '+676',
            code: 'TO'
        },
        {
            name: 'Trinidad y Tobago',
            dial_code: '+1 868',
            code: 'TT'
        },
        {
            name: 'Túnez',
            dial_code: '+216',
            code: 'TN'
        },
        {
            name: 'Turkmenistán',
            dial_code: '+993',
            code: 'TM'
        },
        {
            name: 'Turquía',
            dial_code: '+90',
            code: 'TR'
        },
        {
            name: 'Tuvalu',
            dial_code: '+688',
            code: 'TV'
        },
        {
            name: 'Ucrania',
            dial_code: '+380',
            code: 'UA'
        },
        {
            name: 'Uganda',
            dial_code: '+256',
            code: 'UG'
        },
        {
            name: 'Uruguay',
            dial_code: '+598',
            code: 'UY'
        },
        {
            name: 'Uzbekistán',
            dial_code: '+998',
            code: 'UZ'
        },
        {
            name: 'Vanuatu',
            dial_code: '+678',
            code: 'VU'
        },
        {
            name: 'Venezuela',
            dial_code: '+58',
            code: 'VE'
        },
        {
            name: 'Vietnam',
            dial_code: '+84',
            code: 'VN'
        },
        {
            name: 'Wallis y Futuna',
            dial_code: '+681',
            code: 'WF'
        },
        {
            name: 'Yemen',
            dial_code: '+967',
            code: 'YE'
        },
        {
            name: 'Yibuti',
            dial_code: '+253',
            code: 'DJ'
        },
        {
            name: 'Zambia',
            dial_code: '+260',
            code: 'ZM'
        },
        {
            name: 'Zimbabue',
            dial_code: '+263',
            code: 'ZW'
        }
    ]
};

const getters = {
    getCodigosPais: state => state.codigosPais,
    getProvinciasEspana: state => state.provinciasEspana
};

const mutations = {
    SET_CODIGOS_PAIS(state, codigos) {
        state.codigosPais = codigos;
    }
};

const actions = {
    loadCodigosPais({ commit }) {
        commit('SET_CODIGOS_PAIS', state.codigosPais);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}; 
